import React from "react";

import SundayAmountMinimumStayDataType from "./SundayAmountMinimumStayDataType";
import MondayAmountMinimumStayDataType from "./MondayAmountMinimumStayDataType";
import TuesdayAmountMinimumStayDataType from "./TuesdayAmountMinimumStayDataType";
import WednesdayAmountMinimumStayDataType from "./WednesdayAmountMinimumStayDataType";
import ThursdayAmountMinimumStayDataType from "./ThursdayAmountMinimumStayDataType";
import FridayAmountMinimumStayDataType from "./FridayAmountMinimumStayDataType";
import SaturdayAmountMinimumStayDataType from "./SaturdayAmountMinimumStayDataType";
import AccommodationsDataType from "./AccommodationsDataType";
import AgeRangeDataType from "./AgeRangeDataType";
import AppliedToDataType from "./AppliedToDataType";
import AutomaticPriceRuleAppliedToDataType from "./AutomaticPriceRuleAppliedToDataType";
import BooleanDataType from "./BooleanDataType";
import BillingPolicyDataType from "./BillingPolicyDataType";
import BillingPoliciesDataType from "./BillingPoliciesDataType";
import CampaignScheduleDataType from "./CampaignScheduleDataType";
import CancellationRulesDataType from "./CancellationRulesDataType";
import CardDataType from "./CardDataType";
import CardOrCashDataType from "./CardOrCashDataType";
import ChartTypesDataType from "./ChartTypesDataType";
import ConnectedRoomsDataType from "./ConnectedRoomsDataType";
import ColorDataType from "./ColorDataType";
import CurrencyDataType from "./CurrencyDataType";
import CustomerDataType from "./CustomerDataType";
import EmailAdressDataType from "./EmailAdressDataType";
import CustomersDataType from "./CustomersDataType";
import FormFieldsDataType from "./FormFieldsDataType";
import DateDataType from "./DateDataType";
import DateTimeDataType from "./DateTimeDataType";
import DateOnlyDataType from "./DateOnlyDataType";
import DefaultDataType from "./DefaultDataType";
import DeliveryStatusDataType from "./DeliveryStatusDataType";
import EllipsedListDataType from "./EllipsedListDataType";
import EmailMessageDataType from "./EmailMessageDataType";
import EmailTimePeriodDataType from "./EmailTimePeriodDataType";
import EnabledRatesDataType from "./EnabledRatesDataType";
import EstimatedTimeDataType from "./EstimatedTimeDataType";
import FileUploadsDataType from "./FileUploadsDataType";
import FoliosDataType from "./FoliosDataType";
import FolioItemsDataType from "./FolioItemsDataType";
import GuestTypesDataType from "./GuestTypesDataType";
import HoldStatusDataType from "./HoldStatusDataType";
import HousekeepingTypeDataType from "./HousekeepingTypeDataType";
import HousekeepingTypesDataType from "./HousekeepingTypesDataType";
import HtmlDataType from "./HtmlDataType";
import IntegerDataType from "./IntegerDataType";
import IncidentalDataType from "./IncidentalDataType";
import ImageDataType from "./ImageDataType";
import NotificationIconDataType from "./NotificationIconDataType";
import OrderFormsDataType from "./OrderFormsDataType"
import OtasDataType from "./OtasDataType"
import OverriddenRoomTypePricesDataType from "./OverriddenRoomTypePricesDataType";
import OwnerDataType from "./OwnerDataType";
import PaymentAmountDataType from "./PaymentAmountDataType";
import PaymentTypeDataType from "./PaymentTypeDataType";
import PercentageDataType from "./PercentageDataType";
import PermissionsDataType from "./PermissionsDataType";
import PortalReservationSegmentStatusDataType from "./PortalReservationSegmentStatusDataType";
import PortalRoomTypeDataType from "./PortalRoomTypeDataType";
import ProductsDataType from "./ProductsDataType";
import ProductTaxDataType from "./ProductTaxDataType";
import PropertiesRolesDataType from "./PropertiesRolesDataType";
import PropertyStatusDataType from "./PropertyStatusDataType";
import RateDataType from "./RateDataType";
import DisabledRateDataType from "./DisabledRateDataType";
import RatesDataType from "./RatesDataType";
import RentalsUnitedAmenitiesDataType from "./RentalsUnitedAmenitiesDataType";
import RequestResponseDataType from "./RequestResponseDataType";
import ReservationDataType from "./ReservationDataType";
import ReservationSegmentsDataType from "./ReservationSegmentsDataType";
import ReservationSegmentStatusDataType from "./ReservationSegmentStatusDataType";
import ReservationSegmentCheckInCheckOutActionsDataType from "./ReservationSegmentCheckInCheckOutActionsDataType";
import RoomDataType from "./RoomDataType";
import RoomsDataType from "./RoomsDataType";
import RoomTypeDataType from "./RoomTypeDataType";
import DisabledRoomTypeDataType from "./DisabledRoomTypeDataType";
import RoomPopoverDataType from "./RoomPopoverDataType";
import RoomTypesDataType from "./RoomTypesDataType";
import RuTaskFrequencyDataType from "./RuTaskFrequencyDataType";
import FormsDataType from "./FormsDataType";
import SeasonalPricesDataType from "./SeasonalPricesDataType";
import SeasonalRatesDataType from "./SeasonalRatesDataType";
import SeasonTypeDataType from "./SeasonTypeDataType";
import SeasonsDataType from "./SeasonsDataType";
import ScheduledDateDataType from "./ScheduledDateDataType";
import StringDataType from "./StringDataType";
import StringWithClassDataType from "./StringWithClassDataType";
import SurveyFormsDataType from "./SurveyFormsDataType"
import TaxDatesRatesDataType from "./TaxDatesRatesDataType";
import TaskFrequencyDataType from "./TaskFrequencyDataType";
import TaxOrFeeDataType from "./TaxOrFeeDataType";
import TaxOrFeeRateDataType from "./TaxOrFeeRateDataType";
import TranslatedStringDataType from "./TranslatedStringDataType";
import UserDataType from "./UserDataType";
import StartEndTimeDataType from "./StartEndTimeDataType";
import StayTypeDataType from "./StayTypeDataType";
import RolesDataType from "./RolesDataType";
import DashboardChartsDataType from "./DashboardChartsDataType";
import DashboardWidgetsDataType from "./DashboardWidgetsDataType";
import NoteDataType from "./NoteDataType";
import WordBreakStringDataType from "./WordBreakStringDataType";
import EllipsedString from "./EllipsedString";
import PriceRulesForDateRangeDataType from "./PriceRulesForDateRangeDataType";
import FormTypeDataType from "./FormTypeDataType";
import ReservationSegmentScoreDataType from "./ReservationSegmentScoreDataType";
// import FormsDataType from "./FormsDataType";

var DataTypeHelper = {
  renderColumn: function (data_type, data, props, header) {

    var DataTypeComponents = {
      SundayAmountMinimumStay: SundayAmountMinimumStayDataType,
      MondayAmountMinimumStay: MondayAmountMinimumStayDataType,
      TuesdayAmountMinimumStay: TuesdayAmountMinimumStayDataType,
      WednesdayAmountMinimumStay: WednesdayAmountMinimumStayDataType,
      ThursdayAmountMinimumStay: ThursdayAmountMinimumStayDataType,
      FridayAmountMinimumStay: FridayAmountMinimumStayDataType,
      SaturdayAmountMinimumStay: SaturdayAmountMinimumStayDataType,
      Accommodations: AccommodationsDataType,
      AgeRange: AgeRangeDataType,
      AppliedTo: AppliedToDataType,
      AutomaticPriceRuleAppliedTo: AutomaticPriceRuleAppliedToDataType,
      Boolean: BooleanDataType,
      BillingPolicy: BillingPolicyDataType,
      BillingPolicies: BillingPoliciesDataType,
      CampaignSchedule: CampaignScheduleDataType,
      CancellationRules: CancellationRulesDataType,
      Card: CardDataType,
      CardOrCash: CardOrCashDataType,
      ChartTypes: ChartTypesDataType,
      ConnectedRooms: ConnectedRoomsDataType,
      Color: ColorDataType,
      Currency: CurrencyDataType,
      Customer: CustomerDataType,
      EmailAdress: EmailAdressDataType,
      Customers: CustomersDataType,
      FormFields: FormFieldsDataType,
      Date: DateDataType,
      DateTime: DateTimeDataType,
      DateOnly: DateOnlyDataType,
      Default: DefaultDataType,
      DeliveryStatus: DeliveryStatusDataType,
      EmailMessage: EmailMessageDataType,
      EmailTimePeriod: EmailTimePeriodDataType,
      EnabledRates: EnabledRatesDataType,
      EstimatedTime: EstimatedTimeDataType,
      EllipsedString: EllipsedString,
      EllipsedList: EllipsedListDataType,
      FileUploads: FileUploadsDataType,
      Folios: FoliosDataType,
      FolioItems: FolioItemsDataType,
      GuestTypes: GuestTypesDataType,
      HoldStatus: HoldStatusDataType,
      HousekeepingType: HousekeepingTypeDataType,
      HousekeepingTypes: HousekeepingTypesDataType,
      Html: HtmlDataType,
      Integer: IntegerDataType,
      Incidental: IncidentalDataType,
      Image: ImageDataType,
      NotificationIcon: NotificationIconDataType,
      NoteDataType: NoteDataType,
      OrderForms: OrderFormsDataType,
      Otas: OtasDataType,
      OverriddenRoomTypePrices: OverriddenRoomTypePricesDataType,
      Owner: OwnerDataType,
      PaymentAmount: PaymentAmountDataType,
      PaymentType: PaymentTypeDataType,
      Percentage: PercentageDataType,
      Permissions: PermissionsDataType,
      PortalReservationSegmentStatus: PortalReservationSegmentStatusDataType,
      PortalRoomType: PortalRoomTypeDataType,
      Products: ProductsDataType,
      ProductTaxDataType: ProductTaxDataType,
      PropertiesRoles: PropertiesRolesDataType,
      PropertyStatus: PropertyStatusDataType,
      Rate: RateDataType,
      DisabledRate: DisabledRateDataType,
      Rates: RatesDataType,
      RentalsUnitedAmenities: RentalsUnitedAmenitiesDataType,
      RequestResponse: RequestResponseDataType,
      Reservation: ReservationDataType,
      ReservationSegments: ReservationSegmentsDataType,
      ReservationSegmentStatus: ReservationSegmentStatusDataType,
      ReservationSegmentCheckInCheckOutActions:
        ReservationSegmentCheckInCheckOutActionsDataType,
      Room: RoomDataType,
      Rooms: RoomsDataType,
      RoomType: RoomTypeDataType,
      DisabledRoomType: DisabledRoomTypeDataType,
      RoomPopover: RoomPopoverDataType,
      RoomTypes: RoomTypesDataType,
      RuTaskFrequency: RuTaskFrequencyDataType,
      Forms: FormsDataType,
      SurveyForms: SurveyFormsDataType,
      SeasonalPrices: SeasonalPricesDataType,
      SeasonalRates: SeasonalRatesDataType,
      SeasonType: SeasonTypeDataType,
      Seasons: SeasonsDataType,
      ScheduledDate: ScheduledDateDataType,
      String: StringDataType,
      StringWithClass: StringWithClassDataType,
      TaxDatesRates: TaxDatesRatesDataType,
      TaskFrequency: TaskFrequencyDataType,
      TaxOrFee: TaxOrFeeDataType,
      TaxOrFeeRate: TaxOrFeeRateDataType,
      TranslatedString: TranslatedStringDataType,
      User: UserDataType,
      StartEndTime: StartEndTimeDataType,
      StayType: StayTypeDataType,
      Roles: RolesDataType,
      DashboardCharts: DashboardChartsDataType,
      DashboardWidgets: DashboardWidgetsDataType,
      WordBreakStringDataType: WordBreakStringDataType,
      PriceRulesForDateRange: PriceRulesForDateRangeDataType,
      FormType: FormTypeDataType,
      Forms: FormsDataType,
      ReservationSegmentScore: ReservationSegmentScoreDataType,
    };

    var DataTypeComponent =
      DataTypeComponents[
        data_type in DataTypeComponents ? data_type : "Default"
      ];

    return <DataTypeComponent data={data} header={header} {...props} />;
  },

  renderPopoverMenu: function (data) {
    if (data && data.actions && data.actions.length) {
      var actions = "";

      for (var i = 0, ilen = data.actions.length; i < ilen; i++) {
        var action = data.actions[i];
        actions +=
          "<a href='" +
          action.path +
          "' class='btn btn-dark btn-block modal-iframe' data-nested='true' data-fullscreen='true'>" +
          I18n.t(action.name) +
          "</a>";
      }

      var popover =
        '<div><div class="popover-close-wrapper"><button type="button" class="close" onclick="$(this).parents(\'.popover\').popover(\'hide\');">';
      popover +=
        '<span aria-hidden="true">×</span><span class="sr-only">Close</span></button></div>';
      popover += actions + "</div>";

      return popover;
    }
  },
};

export default DataTypeHelper;
